<template>
    <div class="container">
        <header class="page-header">
            <h2 class="heading">{{ $t('modals.refer_patient.buttons.refer') }}</h2>
            <div class="main">
                <div>
                    <h3 class="heading_title">
                        {{ $t('modals.patient_profile.profile.detail_form.refer_patient_tab.heading') }}
                    </h3>
                    <p class="subtitle">{{ $t('modals.patient_profile.profile.detail_form.refer_patient_tab.subheading') }}</p>
                </div>
            </div>
        </header>

        <div class="refer-cards-container">
            <article class="refer-card">
                <div class="icon-wrapper icon-wrapper--direct">
                    <common-icon name="refer" size="extra-huge"></common-icon>
                </div>
                <div class="header">
                    <h3 class="title">{{ $t('layouts.app.topnav.direct_referral') }}</h3>
                    <span class="badge badge--direct">{{ $t('common.referral_type.direct') }}</span>
                    <p class="description">
                        {{ $t('modals.patient_profile.profile.detail_form.refer_patient_tab.direct_description') }}
                    </p>
                </div>

                <div class="refer-card__actions">
                    <button
                        type="button"
                        class="refer-card__btn refer-card__btn--direct"
                        @click="openDirectReferral(PracticeTypeEnum.PHYSICIAN)"
                    >
                        <common-icon name="aala" size="small"></common-icon>
                        <span>{{ $t('layouts.app.topnav.direct_physican') }}</span>
                    </button>
                    <button
                        type="button"
                        class="refer-card__btn refer-card__btn--direct"
                        @click="openDirectReferral(PracticeTypeEnum.ANCILLARY)"
                    >
                        <common-icon name="building" size="small"></common-icon>
                        <span>{{ $t('layouts.app.topnav.direct_ancillary') }}</span>
                    </button>
                </div>
            </article>

            <article class="refer-card">
                <div class="icon-wrapper icon-wrapper--match">
                    <common-icon name="users" size="extra-huge"></common-icon>
                </div>
                <div class="header">
                    <h3 class="title">{{ $t('layouts.app.topnav.match_referral') }}</h3>
                    <span class="badge badge--match">
                        {{ $t('modals.patient_profile.profile.detail_form.refer_patient_tab.match_badge') }}
                    </span>
                    <p class="description">
                        {{ $t('layouts.app.topnav.match_referral_description') }}.
                        {{ $t('modals.patient_profile.profile.detail_form.refer_patient_tab.match_description') }}
                    </p>
                </div>

                <div class="refer-card__actions">
                    <button
                        type="button"
                        class="refer-card__btn refer-card__btn--match"
                        @click="openMatchReferral(PracticeTypeEnum.PHYSICIAN)"
                    >
                        <common-icon name="aala" size="small"></common-icon>
                        <span>{{ $t('layouts.app.topnav.match_physican') }}</span>
                    </button>
                    <button
                        type="button"
                        class="refer-card__btn refer-card__btn--match"
                        @click="openMatchReferral(PracticeTypeEnum.ANCILLARY)"
                    >
                        <common-icon name="building" size="small"></common-icon>
                        <span>{{ $t('layouts.app.topnav.match_ancillary') }}</span>
                    </button>
                </div>
            </article>

            <article v-if="!isUserPracticeOther" class="refer-card">
                <div class="icon-wrapper icon-wrapper--eprescribe">
                    <common-icon name="navigation" size="extra-huge"></common-icon>
                </div>
                <div class="header">
                    <h3 class="title">{{ $t('layouts.app.topnav.eprescribe') }}</h3>
                    <span class="badge badge--eprescribe">
                        {{ $t('modals.patient_profile.profile.detail_form.refer_patient_tab.epres_badge') }}
                    </span>
                    <p class="description">
                        {{ $t('layouts.app.topnav.eprescribe_description') }}.
                        {{ $t('modals.patient_profile.profile.detail_form.refer_patient_tab.epres_description') }}
                    </p>
                </div>

                <div class="refer-card__actions refer-card__actions--single">
                    <button
                        type="button"
                        class="refer-card__btn refer-card__btn--eprescribe refer-card__btn--primary"
                        @click="openEprescribe"
                    >
                        <common-icon name="eprescribe" size="small"></common-icon>
                        <span>{{ $t('layouts.app.topnav.eprescribe') }}</span>
                    </button>
                </div>
            </article>
        </div>
        <div class="security-note">
            <span class="security-note__icon">
                <common-icon name="verify" size="small"></common-icon>
            </span>

            <span>{{ $t('modals.patient_profile.profile.detail_form.refer_patient_tab.security_note') }}</span>
        </div>
    </div>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        props: {
            patientDetails: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                PracticeTypeEnum,
            }
        },

        computed: {
            patientId() {
                return this.patientDetails?.id || this.$route.params.id || null
            },

            isUserPracticeOther() {
                return this.$auth.isUserPracticeOther()
            },
        },

        methods: {
            openDirectReferral(practiceType) {
                this.emitEvent({ name: 'open-direct-referral', payload: practiceType })
            },

            openMatchReferral(practiceType) {
                const query = { practiceType }

                if (this.patientId) {
                    query.patientId = this.patientId
                }

                this.$router.push({
                    name: 'pool.new',
                    query,
                })
            },

            openEprescribe() {
                const query = {}
                if (this.patientId) {
                    query.patientId = this.patientId
                }
                this.$router.push({
                    name: 'referrals.eprescribe',
                    query,
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';

    .heading {
        font-size: 16px;
        color: oklch(0.21 0.034 264.665);
        font-weight: 500;
        margin-bottom: 14px;
    }
    .heading_title {
        font-size: 18px;
        color: oklch(0.21 0.034 264.665);
        font-weight: 500;
    }
    .subtitle {
        color: #666;
        margin-bottom: 16px;
        font-size: 12px;
        font-weight: 400;
    }
    .main {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .refer-cards-container {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
        align-items: stretch;
        margin-top: 16px;
    }

    .refer-card {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        min-height: 260px;
        padding: 20px;
        background: #ffffff;
        border: 1px solid #ddd;
        border-radius: 12px;
    }

    .header {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 14px;
        margin-bottom: 18px;
        margin-top: 20px;
    }

    .icon-wrapper {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 88px;
        height: 88px;
        border-radius: 50%;
        border: 1px solid;
        margin-top: 20px;
        &--direct {
            background: #eff6ff;
            border-color: #dbeafe;
            color: #2563eb;

            i {
                color: inherit !important;
            }

            svg {
                color: inherit;
                fill: currentColor;
                stroke: currentColor;
            }
        }

        &--match {
            background: #f5f3ff;
            border-color: #e9d5ff;
            color: #7c3aed;

            i {
                color: inherit !important;
            }

            svg {
                color: inherit;
                fill: currentColor;
                stroke: currentColor;
            }
        }

        &--eprescribe {
            background: #ecfdf5;
            border-color: #d1fae5;
            color: #059669;

            i {
                color: inherit !important;
            }

            svg {
                color: inherit;
                fill: currentColor;
                stroke: currentColor;
            }
        }
    }

    .title {
        font-size: 18px;
        font-weight: 600;
        color: #0f172a;
    }

    .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 3px 7px;
        border-radius: 999px;
        font-size: 10px;
        font-weight: 600;
        border: 1px solid #e2e8f0;
        background: #f8fafc;
        color: #475569;
        white-space: nowrap;

        &--direct {
            background: #eff6ff;
            border-color: #dbeafe;
            color: #2563eb;
        }

        &--match {
            background: #f5f3ff;
            border-color: #e9d5ff;
            color: #7c3aed;
        }

        &--eprescribe {
            background: #ecfdf5;
            border-color: #d1fae5;
            color: #059669;
        }
    }

    .description {
        margin: 0;
        color: #64748b;
        font-size: 13px;
        line-height: 1.55;
        text-align: center;
    }

    .refer-card__actions {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 8px;
        margin-top: auto;
        padding-top: 18px;
    }

    .refer-card__actions--single {
        display: flex;
        justify-content: flex-start;
    }

    .refer-card__btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-height: 38px;
        padding: 8px 12px;
        border-radius: 7px;
        border: 1px solid #cbd5e1;
        background: #ffffff;
        color: #334155;
        font-size: 13px;
        line-height: 1.2;
        font-weight: 600;
        cursor: pointer;
        transition: all 150ms ease;

        &:hover {
            background: #f8fafc;
            border-color: #94a3b8;
        }

        &:focus-visible {
            outline: 2px solid #93c5fd;
            outline-offset: 2px;
        }

        &:active {
            transform: translateY(0);
        }

        i {
            font-size: 14px;
            color: inherit !important;
        }

        &--direct {
            background: #eff6ff;
            border-color: #dbeafe;
            color: #2563eb;

            &:hover {
                background: #f8fbff;
                border-color: #93c5fd;
            }
        }

        &--match {
            background: #f5f3ff;
            border-color: #e9d5ff;
            color: #7c3aed;

            &:hover {
                background: #faf5ff;
                border-color: #c4b5fd;
            }
        }

        &--eprescribe {
            background: #ecfdf5;
            border-color: #d1fae5;
            color: #059669;

            &:hover {
                background: #ecfdf5;
                border-color: #86efac;
            }
        }

        &--primary {
            width: fit-content;
        }
    }

    .security-note {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-top: 18px;
        padding: 24px;
        border-radius: 10px;
        border: 1px solid #ddd;
        background: #fff;
        color: #475569;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.5;
    }

    .security-note__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        flex-shrink: 0;
        border-radius: 50%;
        background: #e0f2fe;

        i {
            font-size: 14px;
            color: #0369a1 !important;
        }
    }

    @media (max-width: 980px) {
        .refer-cards-container {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    @media (max-width: 640px) {
        .heading {
            font-size: 22px;
        }

        .refer-cards-container {
            grid-template-columns: 1fr;
        }

        .refer-card {
            min-height: unset;
        }

        .refer-card__actions {
            flex-direction: column;
        }

        .refer-card__btn {
            width: 100%;
        }
    }
</style>
